import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/auth'

const firebaseConfig = {
  apiKey: 'AIzaSyAVUq8eFIa0Cxbt-sRFTGCenBKtZJSqq0M',
  authDomain: 'micomwh.firebaseapp.com',
  projectId: 'micomwh',
  storageBucket: 'micomwh.appspot.com',
  messagingSenderId: '1072484665963',
  appId: '1:1072484665963:web:bf9b597be9ed771b75ff2e',
}

firebase.initializeApp(firebaseConfig)

const firebaseDb = firebase.database()
const firebaseAuth = firebase.auth()

const getDbRef = (dbRef) => {
  const envDbRef = `${process.env.NODE_ENV === 'production' ? 'production' : 'local'}/${dbRef}`
  return firebaseDb.ref(envDbRef)
}

const ChatDb = getDbRef('chat')
const HallOneDb = getDbRef('Hall_A_Chat')
const HallTwoDb = getDbRef('Hall_B_Chat')
const ChatMcDb = getDbRef('chatMc')
const NoticeDb = getDbRef('notice')
const NotificationDb = getDbRef('pushNotifications')

const getUniqueSessionDb = (uid) => getDbRef(`uniqueSession/${uid}`)
const getUserCountDb = (uid, path) => getDbRef(`userCount/${path}/${uid}`)
const getUserSessionDb = (uid) => getDbRef(`userSessions/${uid}`)
const getOnlineStatusDb = (uid) => getDbRef(`onlineStatus/${uid}`)
const getLiveCheckInSessionDb = (hallNumber) => getDbRef(`liveCheckInSession/hall-${hallNumber}`)
const getRefreshDb = (uid) => getDbRef(`shouldRefresh/${uid}`)

export {
  firebaseDb,
  firebaseAuth,
  ChatDb,
  HallOneDb,
  HallTwoDb,
  ChatMcDb,
  NoticeDb,
  NotificationDb,
  getUniqueSessionDb,
  getUserCountDb,
  getUserSessionDb,
  getOnlineStatusDb,
  getLiveCheckInSessionDb,
  getRefreshDb,
}
